import { useNavigate } from "react-router-dom";

const ScrollingAudioBoks = ({image,title,audioID,stream}) => {
    const navigate = useNavigate();

    const handleListen=()=>{
        navigate(`/hrmwaudiobook/${title && title.replace(/" "/g,"%20")}/${audioID}`);
    }


    return (
        <div className="scrollingbook">
            <img src={image && image} id="scrollingbookimg" alt="" />
            {stream && stream > 1 && 
                <div className="scrollingbookstream" style={{backgroundColor: "#eb268f", borderRadius:"10px", width:"auto"}}>
                    <h5 style={{color:"white", fontWeight:"bold"}}>{`${'stream: ' + stream}`}</h5>
                </div>
            }
            <button id="scrollAudioListenBtn" onClick={()=>handleListen()}>Listen</button>
        </div>
      );
}
export default ScrollingAudioBoks;